import { render, staticRenderFns } from "./Nvai.vue?vue&type=template&id=668cb6e4&scoped=true&"
import script from "./Nvai.vue?vue&type=script&lang=js&"
export * from "./Nvai.vue?vue&type=script&lang=js&"
import style0 from "./Nvai.vue?vue&type=style&index=0&id=668cb6e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668cb6e4",
  null
  
)

export default component.exports